import { Component, OnDestroy, OnInit, Type } from "@angular/core";
import { filter, first, switchMap } from "rxjs/operators";
import { CirculationFacade } from "src/app/services/circulation.facade";
import { SubSink } from "subsink";
import { IStepTypeProviderDescription } from "../../interfaces";
import { LogClass, Logger, LogMethod } from "../../logger";
import { StepFacade } from "../services/step.facade";

@Component({
    selector: "circ-work",
    templateUrl: "./work.component.html",
    styleUrls: ["./work.component.scss"],
    standalone: false
})
@LogClass({ source: "WorkComponent" })
export class WorkComponent implements OnInit, OnDestroy {
  public loading = true;
  public providerComponent: Type<unknown>;
  public providers: IStepTypeProviderDescription[];

  private logger: Logger;
  private subscriptions = new SubSink();

  constructor(
    private stepFacade: StepFacade,
    private circulationFacade: CirculationFacade
  ) {
    this.logger.debug("ctor");
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  @LogMethod()
  public ngOnInit(): void {
    const circulation$ = this.circulationFacade
      .getCurrentCirculation()
      .pipe(filter((c) => !!c));

    circulation$
      .pipe(
        switchMap(() => this.stepFacade.getCurrentStepType()),
        filter((s) => !!s),
        first()
      )
      .subscribe((provider) => {
        this.providerComponent = provider.workComponent;
        this.loading = false;
      });
  }
}
